/** Map flight carrier codes to human-readable labels.
 *  The tracker uses "??" for multi-carrier combination itineraries; render it
 *  legibly instead of leaking the placeholder. */
export interface CarrierLabel {
  text: string;
  title?: string;
}

export function carrierLabel(carrier: string): CarrierLabel {
  if (carrier === '??') {
    return { text: 'multi', title: 'Multi-carrier combination itinerary' };
  }
  return { text: carrier };
}
